
































import { Component, Prop, Emit } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { VNode, CreateElement } from 'vue';
import {
  dropdown,
  SwDropdownUnit,
  DropdownDirValues,
} from '@libs-uuif/shared/dropdown-dir';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { messageService } from '@libs-uuif/shared/message-service';
import { unifiedMessageContainer } from '@/shared/constants';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { ccReportingApi } from './shared/cc-reporting-api';
import { nsmReportingApi } from './shared/nsm-reporting-api';
import fileDownload from 'js-file-download';
import { sessionStorageKeeperService } from '@/shared/auth-service';
import { wcmApiService } from '@/shared/api-service/wcm-api-service';
import { State } from 'vuex-class';
import { CoreStoreState } from '@/core';
import { RootStoreState } from '@/store';
import { nsmApiService } from '@/shared/api-service/nsm-api-service';

const cssPrefix = 'report-actions';

@Component({
  components: {
    SwIconButton,
    SwDropdownUnit,
  },
  directives: {
    dropdown,
  },
})
export default class ReportActions extends SwExtendedVue {
  cssPrefix = cssPrefix;
  showDropdown: boolean = false;
  autoHide: boolean = true;

  @Prop({ default: true })
  enableEditDelete: boolean;

  @Prop()
  reportData: any;

  @State((state: RootStoreState) => state.CoreStoreModule.nsmBaseUrl)
  nsmBaseUrl: CoreStoreState['nsmBaseUrl'];

  @State((state: RootStoreState) => state.CoreStoreModule.ccBaseUrl)
  ccBaseUrl: CoreStoreState['ccBaseUrl'];
  /*
    @desc Returns action dropdown for table entry.
  */
  options = [
    {
      content: this.$t('home.download')
      .toString(),
      action: 'download',
    },
    {
      content: this.$t('common.edit')
      .toString(),
      action: 'edit',
    },
    {
      content: this.$t('common.delete')
      .toString(),
      action: 'delete',
    },
  ];
  get actionsDropdown(): DropdownDirValues {
    return {
      // tslint:disable-next-line
      content: (h: CreateElement): VNode[] => {
        const nodes: VNode[] = [];
        this.getOptions.map((item) => {
          nodes.push(
            (
              <div class={[`${cssPrefix}__dropdown-border`]}>
                {
                  <SwDropdownUnit
                    nativeOn-click={() => this.performAction(item.action)}
                    disabled={this.disabledProp(item)}
                  >
                    {this.actionName(item)}
                  </SwDropdownUnit>
                }
              </div>
            ) as VNode,
          );
        });
        return nodes;
      },
      visible: this.showDropdown,
      placement: 'bottom-end',
      onClickOutsidePopper: () => {
        this.showDropdown = false;
      },
    };
  }

  created() {
    this.addRunNowOptions();
  }

  addRunNowOptions() {
    if (this.reportData.productName === 'firewall' &&
      this.reportData.reportType === 'Rules') {
      if (!this.options.find((option: {content: string, action:string}) => option.action === 'runnow')) {
        this.options.unshift({ content: 'Run now', action: 'runnow' });
      }
    }
  }

  get getOptions() {
    return this.options;
  }

  actionName(item: any) {
    return  item.content;
  }

  disabledProp(item: any) {
    if (
      this.reportData.productName === 'Capture Client' &&
      this.reportData.reportType === 'OnDemand' &&
      (item.action === 'edit' || item.action === 'delete')
    ) {
      return true;
    }
    if (
      this.reportData.productName === 'Capture Client' &&
      this.reportData.reportType === 'OnDemand' &&
      this.reportData.delivery_method === 'Email' &&
      (item.action === 'edit' || item.action === 'delete' || item.action === 'download')
    ) {
      return true;
    }
    if (
      this.reportData.productName === 'firewall' &&
      this.reportData.reportType === 'Archived' &&
      item.action === 'edit'
    ) {
      return true;
    }
    if (
      this.reportData.productName === 'firewall' &&
      this.reportData.reportType === 'Rules' &&
      item.action === 'runnow' &&
      this.reportData.status === 'Progress'
    ) {
      return true;
    }
    if (
      this.reportData.productName === 'firewall' &&
      this.reportData.reportType === 'Rules' &&
      item.action === 'download' &&
      (!this.reportData.archiveFiles || this.reportData.archiveFiles.length === 0)
    ) {
      return true;
    }
    if (this.reportData.productName === 'Wireless' && this.reportData.report_type === 'ondemand' && item.action === 'edit') {
      return true;
    }
    if (this.reportData.productName === 'Wireless' &&
      this.reportData.report_type === 'schedule' &&
      item.action === 'download' &&
      this.reportData.status === 'Wait') {
      return true;
    }
    if (
      this.reportData.productName === 'Wireless' &&
     (this.reportData.status === 'Processing' || this.reportData.status === 'New') &&
      (item.action === 'delete' || item.action === 'download')
    ) {
      return true;
    }
    if (item.action === 'delete' && !this.enableEditDelete) {
      return true;
    }
    return false;
  }

  async getCaptureClientOnDemandReport() {
    const id = this.reportData.taskId;
    messageService.messageManager.showMessage(
      unifiedMessageContainer,
      this.$t('spog.unifiedInsights.rprtDwnlding')
      .toString(),
      'informational',
    );
    ccReportingApi
      .download(this.ccBaseUrl, id)
      .then((response: any) => {
        fileDownload(
          response.data,
          `${this.reportData.report_name}.${this.reportData.fileFormat}`,
        );
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.rprtSucc')
          .toString(),
          'success',
        );
      })
      .catch((error: any) => {
        console.error('Report download API error ', error);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.rprtFail')
          .toString(),
          'failed',
        );
      });
  }

  async getCaptureClientScheduledReport() {
    const ccScheduleReportData = this.reportData.ccScheduleReportData;
    messageService.messageManager.showMessage(
      unifiedMessageContainer,
      this.$t('spog.unifiedInsights.rprtDwnlding')
      .toString(),
      'informational',
    );
    await ccReportingApi
      .generateCCScheduleReport(this.ccBaseUrl, this.getCCApiParams(ccScheduleReportData))
      .then((response) => {
        const taskId = response?.data?.taskId || '';
        this.downloadEvery30Seconds(this.downloadCcScheduleReports.bind(this, taskId), 30 * 1000);
      })
      .catch((error: any) => {
        console.error('Report Download API error ', error);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.rprtDnldFail')
            .toString(),
          'failed',
        );
      });
  }

  downloadEvery30Seconds(callBack: Function, interval: number) {
    const timer = setInterval(
      () => {
        callBack(timer);
      },
      interval,
    );
    callBack(timer);
  }

  async downloadCcScheduleReports(taskId: any, timer: any) {
    await ccReportingApi
      .download(this.ccBaseUrl, taskId)
      .then((response: any) => {
        if (response.status !== 404) {
          clearInterval(timer);
          fileDownload(
            response.data,
            // `${this.reportData.report_name}.${this.reportData.fileFormat}`,
            `${this.reportData.report_name}.zip`,
          );
        }
      })
      .catch((error: any) => {
        console.error('Report Download API error ', error);
      });
  }

  getCCApiParams(ccScheduleReportData: any) {
    return {
      frequency: ccScheduleReportData.schedule,
      nbItems:
        ccScheduleReportData.schedule === 'hourly'
          ? 24
          : ccScheduleReportData.schedule === 'daily'
          ? 30
          : ccScheduleReportData.schedule === 'weekly'
          ? 26
          : ccScheduleReportData.schedule === 'monthly'
          ? 12
          : 30,
      name: ccScheduleReportData.threatsSection,
      action: 'Download',
      emails: [],
      sections: [{
        name:'generalInformation',
        content: ccScheduleReportData.generalInformationSection || 'none',
      }, {
        name:'threats',
        content: ccScheduleReportData.threatsSection || 'none',
      }, {
        name:'atp',
        content: ccScheduleReportData.atpSection || 'none',
      }, {
        name:'devices',
        content: ccScheduleReportData.devicesSection || 'none',
      }, {
        name:'activities',
        content: ccScheduleReportData.activitiesSection || 'none',
      }, {
        name:'webProtection',
        content: ccScheduleReportData.webProtectionSection || 'none',
      }, {
        name:'applications',
        content: ccScheduleReportData.applicationsSection || 'none',
      }, {
        name:'tenants',
        content: ccScheduleReportData.tenantsSection || 'none',
      }, {
        name: 'alerts',
        content: `${ccScheduleReportData.includeAlerts  ||  false }`,
      }, {
        name: 'riskyDevicesList',
        content:  `${ccScheduleReportData.includeRiskyDevicesList || false }`,
      }, {
        name:'riskyAppsList',
        content: `${ccScheduleReportData.includeRiskyAppsList || false }`,
      }, {
        name: 'threatHistory',
        content: `${ccScheduleReportData.includeThreatHistory || false }`,
      }, {
        name: 'atpHistory',
        content: `${ccScheduleReportData.includeAtpHistory || false }`,
      }, {
        name: 'deviceHistory',
        content: `${ccScheduleReportData.includeDeviceHistory || false }`,
      }, {
        name: 'threatList',
        content: `${ccScheduleReportData.includeThreatList || false }`,
      }, {
        name: 'atpList',
        content: `${ccScheduleReportData.includeAtpList || false }`,
      }, {
        name: 'deviceList',
        content: `${ccScheduleReportData.includeDeviceList || false }`,
      }, {
        name: 'infectedDeviceList',
        content: `${ccScheduleReportData.includeInfectedDeviceList || false }`,
      }, {
        name: 'tenantList',
        content: `${ccScheduleReportData.includeTenantList || false }`,
      }],
    };
  }

  async deleteCCScheduledReport() {
    const scheduleId = this.reportData.ccScheduleReportData.scheduleId;
    messageService.messageManager.showMessage(
      unifiedMessageContainer,
      this.$t('spog.unifiedInsights.rprtDel')
      .toString(),
      'informational',
    );

    await ccReportingApi
      .deleteSchedule(this.ccBaseUrl, scheduleId)
      .then(() => {
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.rprtDelSucc')
          .toString(),
          'success',
        );
        this.$emit('actionPerformed', true);
      })
      .catch((error: any) => {
        console.error('Report API Error', error);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.rprtDelFail')
          .toString(),
          'failed',
        );
      });
  }
  async deleteNsmScheduledReport() {
    const scheduleId = this.reportData.scheduleId;
    messageService.messageManager.showMessage(
      unifiedMessageContainer,
      this.$t('spog.unifiedInsights.rprtDel')
      .toString(),
      'informational',
    );

    await nsmReportingApi
      .deleteNsmScheduleReport(this.nsmBaseUrl, scheduleId)
      .then(() => {
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.rprtDelSucc')
          .toString(),
          'success',
        );
        this.$emit('actionPerformed', true);
      })
      .catch((error: any) => {
        console.error('Report API Error', error);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.rprtDelFail')
          .toString(),
          'failed',
        );
      });
  }

  async deleteNsmArchivedReport() {
    const id = this.reportData.scheduleId || '';
    messageService.messageManager.showMessage(
      unifiedMessageContainer,
      this.$t('spog.unifiedInsights.rprtDel')
      .toString(),
      'informational',
    );

    await nsmReportingApi
      .deleteNsmArchivedReport(this.nsmBaseUrl, id)
      .then(() => {
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.rprtDelSucc')
          .toString(),
          'success',
        );
        this.$emit('actionPerformed', true);
      })
      .catch((error: any) => {
        console.error('Report API Error', error);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.rprtDelFail')
          .toString(),
          'failed',
        );
      });
  }

  async downloadNsmArchivedReport() {
    const id = this.reportData.archiveFiles[0]._id || 0;
    const view = this.reportData.view;
    messageService.messageManager.showMessage(
      unifiedMessageContainer,
      this.$t('spog.unifiedInsights.rprtDwnlding')
      .toString(),
      'informational',
    );
    await nsmReportingApi
      .downloadNsmArchivedReport(this.nsmBaseUrl, id, view)
      .then((response: any) => {
        if (response.data.fileData) {
          const binaryString = atob(response.data.fileData.replace(/\s/g, ''));
          const stringLength = binaryString.length;
          const buffer = new ArrayBuffer(stringLength);
          const data = new Uint8Array(buffer);
          for (let i = 0; i < stringLength; i = i + 1) {
            data[i] = binaryString.charCodeAt(i);
          }
          const blob = new Blob([data], { type: 'application/zip' });
          const url = window.URL.createObjectURL(blob);
          window.open(url);
          messageService.messageManager.showMessage(
            unifiedMessageContainer,
            this.$t('spog.unifiedInsights.rprtSucc')
            .toString(),
            'success',
          );
        } else {
          messageService.messageManager.showMessage(
            unifiedMessageContainer,
            this.$t('spog.unifiedInsights.rprtDnldFail')
            .toString(),
            'failed',
          );
        }
      })
      .catch((error: any) => {
        console.error('Report Download API error ', error);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.rprtDnldFail')
            .toString(),
          'failed',
        );
      });
  }

  runNsmRulesReport() {
    // const interval = this.getInterval(this.reportData);
    const id = [`${this.reportData.scheduleId}`];
    const force = true;
    // const endTS = new Date().getTime();
    // const startTS = endTS - (interval * 24 * 3600 * 1000);
    const endTs = 0;
    const startTs = 0;

    nsmApiService
      ?.runTaskConfig('/reportgenerator/runschedules', id, startTs, endTs, force)
      .then((response: any) => {
        if (response.status.success) {
          messageService.messageManager.showMessage(
            unifiedMessageContainer,
            response.status.info[0].message,
            'success',
          );
          this.$emit('actionPerformed', true);
        } else {
          messageService.messageManager.showMessage(
            unifiedMessageContainer,
            response.status.info[0].message,
            'failed',
          );
        }
      })
      .catch((error: any) => {
        console.error('Report Run Schedule API error', error);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          'The selected report could not be run, please try again after sometime',
          'failed',
        );
      });
  }

  async deleteWirelessReport() {
    const reportId = this.reportData.id;
    const wcmSession = sessionStorageKeeperService.retrieveJSON('wcmSession');
    let tenantId = '';
    if (
      wcmSession &&
      wcmSession.ssoKeys &&
      wcmSession.ssoKeys.tenants &&
      wcmSession.ssoKeys.tenants.length > 0
    ) {
      tenantId = wcmSession.ssoKeys.tenants[0].tenant_id || '';
    }
    messageService.messageManager.showMessage(
      unifiedMessageContainer,
      this.$t('spog.unifiedInsights.rprtDel')
      .toString(),
      'informational',
    );

    await wcmApiService
      ?.deleteReportWithDelete(`/tenants/${tenantId}/system/reports/task/${reportId}`)
      .then(() => {
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.rprtDelSucc')
          .toString(),
          'success',
        );
        this.$emit('actionPerformed', true);
      })
      .catch((error: any) => {
        console.error('Report API Error', error);
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.rprtDelFail')
          .toString(),
          'failed',
        );
      });
  }

  downloadWirelessReport() {
    const reportName = this.reportData.filename ? this.reportData.filename : `${this.reportData.id}.pdf`;
    const url = this.reportData.url;
    wcmApiService.downloadWirelessReport(reportName, url, false);
  }

  getInterval(data: any) {
    let interval = 1;
    if (data.intervalType === 1) {
      interval = 7;
    } else if (data.intervalType === 2) {
      interval = 30;
    } else {
      interval = 1;
    }
    return interval;
  }

  performAction(actionType: any) {
    switch (actionType) {
      case 'delete':
        // Call function in this case delete
        switch (this.reportData.productName) {
          case 'Capture Client': {
            switch (this.reportData.reportType) {
              case 'OnDemand': {
                // Note : Auto delete after 5 days of report generation
                break;
              }
              case 'Scheduled': {
                this.deleteConfirmation()
                .then((confirmKey) => {
                  if (confirmKey === 'proceed') {
                    this.deleteCCScheduledReport();
                  }
                });
                break;
              }
            }
            break;
          }
          case 'firewall': {
            switch (this.reportData.reportType) {
              case 'Rules': {
                this.deleteConfirmation()
                .then((confirmKey) => {
                  if (confirmKey === 'proceed') {
                    this.deleteNsmScheduledReport();
                  }
                });
                break;
              }

              case 'Archived': {
                this.deleteConfirmation()
                .then((confirmKey) => {
                  if (confirmKey === 'proceed') {
                    this.deleteNsmArchivedReport();
                  }
                });

                break;
              }
            }
            break;
          }
          case 'Wireless':
            {
              {
                this.deleteConfirmation()
                .then((confirmKey) => {
                  if (confirmKey === 'proceed') {
                    this.deleteWirelessReport();
                  }
                });
                break;
              }
            }
            break;
        }

        break;
      case 'edit':
        this.openEditModal();
        break;
      case 'download':
        // Call function in this case delete
        switch (this.reportData.productName) {
          case 'Capture Client': {
            switch (this.reportData.reportType) {
              case 'OnDemand': {
                this.getCaptureClientOnDemandReport();
                break;
              }
              case 'Scheduled': {
                this.getCaptureClientScheduledReport();
                break;
              }
            }
            break;
          }

          case 'firewall': {
            switch (this.reportData.reportType) {
              case 'Rules': {
                this.downloadNsmArchivedReport();
                break;
              }
            }
            break;
          }

          case 'Wireless': {
            this.downloadWirelessReport();
            break;
          }
        }
        break;
      case 'runnow':
        switch (this.reportData.productName) {
          case 'firewall': {
            switch (this.reportData.reportType) {
              case 'Rules': {
                this.runNsmRulesReport();
                break;
              }
            }
            break;
          }
        }
        break;
    }
    this.showDropdown = false;
  }

  private deleteConfirmation() {
    return confirmService.confirm({
      message: this.$t('spog.unifiedInsights.rprtDelSucc')
      .toString(),
      title: this.$t('spog.unifiedInsights.timeFrameMsg')
      .toString(),
      status: 'informational',
      buttons: [
        {
          key: 'cancel',
          name: this.$t('common.cancel')
          .toString(),
        },
        {
          key: 'proceed',
          name: this.$t('spog.unifiedInsights.proceed')
          .toString(),
          isDefault: true,
        },
      ],
    });
  }

  onClickDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.showDropdown = !this.showDropdown;
  }

  @Emit('editSa')
  openEditModal() {}
}
